<template>
  <div>
    <!--  <PageHead title="权限管理"></PageHead> -->
    <PageHead title="业务配置"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="search-flex-item mr20">
          <span>名称：</span>
          <a-input
            allowClear
            class="w200"
            placeholder="请输入名称"
            v-model="queryForm.roleZhName"
          />
        </div>
        <div class="search-flex-item mr20">
          <span>状态：</span>
          <a-select
            allowClear
            placeholder="不限"
            class="w200"
            v-model="queryForm.enableNum"
          >
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="2"> 禁用 </a-select-option>
          </a-select>
        </div>

        <div class="search-flex-item">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel">
            取消
          </a-button>
        </div>
      </div>
      <div class="mt20 mb20">
        <a-button type="primary" @click="add()" icon="plus"> 新建</a-button>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="roleList"
        rowKey="roleId"
        :loading="loading"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="status" class="statusDiv" slot-scope="text, record">
          <a-switch :checked="text == 1" @change="enableNumChange(record)" />
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="add(record)">
            编辑权限
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.roleId)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination v-model="page" :total="total" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal
      v-model="visible"
      title="权限配置"
      @ok="handleOk"
      :width="800"
      :confirm-loading="confirmLoading"
    >
      <div class="role-formCont">
        <span>权限名称:</span>
        <a-input
          class="w300 ml20"
          placeholder="请输入权限名称"
          v-model="addForm.roleZhName"
          @change="eightyfive('roleZhName')"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span>权限说明:</span>
        <a-textarea
          class="w300 ml20"
          placeholder="请输入权限说明"
          v-model="addForm.context"
          @change="eightyfive('context')"
          :rows="2"
        />
      </div>

      <blank height="20"> </blank>
      <div class="role-scrollY">
        <div class="role-formCont" v-for="(i, index) in menuList" :key="index">
          <div class="role-formlabel">{{ i.label }}：</div>
          <div class="role-formvalue">
            <a-checkbox-group v-model="menuIds[index]">
              <a-checkbox
                :value="item.id"
                name="type"
                v-for="(item, index) in i.children"
                :key="index"
              >
                {{ item.label }}
              </a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '权限名称',
    dataIndex: 'roleZhName',
    key: 'roleZhName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '权限说明',
    dataIndex: 'context',
    key: 'context',
    ellipsis: true,
    align: 'left'
  },

  {
    title: '启用',
    dataIndex: 'enableNum',
    key: 'enableNum',
    scopedSlots: { customRender: 'status' },
    ellipsis: true,
    align: 'left'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 160
  }
]
import {
  getRoleList,
  getMenuList,
  addRole,
  updateRole,
  updateRoleEnableNumById,
  delRole,
  getOrganizationRoleMenu
} from './api/api'
export default {
  data() {
    return {
      visible: false,
      queryForm: {
        // enableNum: 0,
        // roleZhName: ''
      },
      addForm: {
        roleZhName: '',
        menuIds: []
      },
      page: 1,
      size: 10,
      total: 0, //总条数
      roleList: [], //权限列表
      menuList: [], // 权限列表
      columns,
      loading: false,
      confirmLoading: false,
      menuIds: []
    }
  },
  computed: {},
  created() {
    this.load()
    getOrganizationRoleMenu().then((res) => {
      //获取权限列表
      this.menuList = res.data.data
    })
    // getMenuList().then((res) => {
    //   //获取权限列表
    //   this.menuList = res.data.data;
    // });
  },
  methods: {
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getRoleList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.roleList = res.data.data
          this.total = res.data.count
        }
      })
    },

    // 输入框限制85
    eightyfive(v) {
      if (this.addForm[v].length > 85) {
        this.addForm[v] = this.addForm[v].substring(0, 85)
        this.$message.destroy()
        this.$message.warning('只能输入85个字')
      }
    },
    enableNumChange(checked) {
      //启用禁用
      let data = {
        roleId: checked.roleId
      }
      if (checked.enableNum == 1) {
        data.enableNum = 2
      } else {
        data.enableNum = 1
      }
      updateRoleEnableNumById(data).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('操作成功')
        }
        this.load()
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delRole({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.load()
            }
          })
        }
      })
    },
    handleOk() {
      // 确认修改/添加
      //数组结构合并
      let addMenuIds = []
      this.menuIds.forEach((item, index, array) => {
        addMenuIds = addMenuIds.concat(item)
      })
      this.addForm.menuIds = addMenuIds
      this.confirmLoading = true
      if (this.addForm.roleId) {
        updateRole(this.addForm).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('操作成功')
            this.load()
            this.visible = false
            this.confirmLoading = false
          } else {
            this.confirmLoading = false
          }
        })
      } else {
        addRole(this.addForm).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('添加成功')
            this.load()
            this.visible = false
            this.confirmLoading = false
          } else {
            this.confirmLoading = false
          }
        })
      }
    },
    //双重数组结构查找
    getTreeIt(dt, n) {
      var value = -1
      dt.forEach((item, index, array) => {
        item.children.forEach((tt) => {
          if (tt.id == n) {
            value = index
          }
        })
      })
      return value
    },
    add(addForm) {
      if (addForm) {
        // 修改
        this.addForm = addForm
        // this.addForm.menuIds = [] //  临时用  接口通之后删掉
        // 需要解构数组 赋值this.menuIds 接口通之后写 ！！！！！！！！！
        // this.addForm.menuIds
        let aaa = []
        if (this.addForm.menuIds.length > 0) {
          this.addForm.menuIds.forEach((item, index, array) => {
            let arrIndex = this.getTreeIt(this.menuList, item)
            if (aaa[arrIndex] && aaa[arrIndex].length > 0) {
              //有数据
              aaa[arrIndex].push(item)
            } else {
              //没数据
              let ddd = []
              ddd.push(item)
              aaa[arrIndex] = ddd
            }
          })
        }
        this.menuIds = aaa
      } else {
        this.addForm = { roleZhName: '', menuIds: [] }
        this.menuIds = []
      }
      this.visible = true
    },

    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      //搜索
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.role-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 500px);
}
// .role-scrollY::-webkit-scrollbar {
//   display: none;
// }
.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/role.vue